import { render, staticRenderFns } from "./AnalyticsView.vue?vue&type=template&id=5144e39c&scoped=true"
import script from "./AnalyticsView.vue?vue&type=script&lang=js"
export * from "./AnalyticsView.vue?vue&type=script&lang=js"
import style0 from "./AnalyticsView.vue?vue&type=style&index=0&id=5144e39c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5144e39c",
  null
  
)

export default component.exports